module.exports = __webpack_public_path__ + "img/loading-val-white.3ee2738c.svg";